module.exports = __webpack_public_path__ + "static/media/um.f2ba7f8f.svg";